const ALLOWED_CF_TYPES = {
  'CF-3GPP-33108': true,
  'CF-ATIS-1000013': true,
  'CF-ETSI-102232': true,
}

export function enableCasePacketHeaderHandover(
  packetSummaryCount: number,
  packetSummaryTimer: number,
  cfType: string,
): boolean {

  if (!packetSummaryCount && !packetSummaryTimer) {
    return false;
  }

  if (!cfType) {
    return false;
  }

  const cfTypeKey = cfType as keyof typeof ALLOWED_CF_TYPES;
  if (!ALLOWED_CF_TYPES[cfTypeKey]) {
    return false;
  }

  return packetSummaryCount > 0 || packetSummaryTimer > 0;
}

export default enableCasePacketHeaderHandover;
